/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

import { Button, HighContrastButton } from "./ButtonPrimitives";

interface Props {
  disabled?: boolean;
  highContrast?: boolean; // whether the button should have the background color opposite of the backgroud
  dangerous?: boolean; // apply the danger style to the button
  onClick?: (e: React.MouseEvent) => void;
  styles?: React.CSSProperties; // additional styles to apply to the button with CSSinJS
  className?: string; // additions styles to apply to the button with StyledComponents
  children: React.ReactNode;
}

export function StandardButton({
  children,
  disabled,
  dangerous = false,
  onClick,
  highContrast,
  className,
  styles,
}: Props) {
  return (
    <>
      {highContrast ? (
        <HighContrastButton
          onClick={(e: React.MouseEvent) => !disabled && onClick && onClick(e)}
          $disabled={disabled}
          style={styles}
          className={className}
        >
          <StyledChildren>{children}</StyledChildren>
        </HighContrastButton>
      ) : (
        <Button
          onClick={(e: React.MouseEvent) => !disabled && onClick && onClick(e)}
          $disabled={disabled}
          $dangerous={dangerous}
          style={styles}
          className={className}
        >
          <StyledChildren>{children}</StyledChildren>
        </Button>
      )}
    </>
  );
}

const StyledChildren = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
